import React, { RefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';

type Props = {
  heroRef: RefObject<HTMLElement | null>;
};

const Swoosh = ({ heroRef }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const update = () => {
      if (!ref.current || !heroRef.current) {
        return;
      }

      const heroBottom = heroRef.current.getBoundingClientRect().bottom;
      const fadeStart = window.innerHeight * 0.45;
      const opacity = (fadeStart - heroBottom) / 260;

      ref.current.style.opacity = String(Math.min(1, Math.max(0, opacity)));
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [heroRef]);

  return <Layer ref={ref} aria-hidden />;
};

const Layer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  pointer-events: none;
  opacity: 0;
  background: url('/images/swoosh.svg') 50% calc(100% + 40.4vw) / 130% auto
    no-repeat;
`;

export default Swoosh;
